import { useState } from "react";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Ticker } from "@/components/site/Ticker";
import { Intro2 } from "@/components/site/Intro2";
import { Reels } from "@/components/site/Reels";
import { Socials } from "@/components/site/Socials";
import { Bento } from "@/components/site/Bento";
import { Pricing } from "@/components/site/Pricing";
import { TintPicker } from "@/components/site/TintPicker";
import { Intro, ScrollProgress } from "@/components/site/Intro";
import { MobileSection } from "@/components/site/MobileSection";
import { Pickup } from "@/components/site/Pickup";
import { Process } from "@/components/site/Process";
import { Gallery } from "@/components/site/Gallery";
import { QuoteForm } from "@/components/site/QuoteForm";
import { Footer } from "@/components/site/Footer";
import { StickyBar } from "@/components/site/StickyBar";

export default function Home() {
  const [services, setServices] = useState([]);
  const [location, setLocation] = useState("in-shop");
  const [tintShade, setTintShade] = useState("");
  const pickShade = (s) => { setTintShade(s); pick("Window Tint"); };
  const pick = (s) => setServices((prev) => (prev.includes(s) ? prev : [...prev, s]));
  return (
    <div className="bg-[#07080B] text-white">
      <Intro />
      <ScrollProgress />
      <SmoothScroll />
      <Nav />
      <main>
        <Hero />
        <Ticker />
        <Intro2 />
        <Reels />
        <Socials />
        <Bento />
        <Pricing onPick={pick} />
        <TintPicker onPick={pickShade} />
        <MobileSection />
        <Pickup onPick={() => setLocation("pickup")} />
        <Process />
        <Gallery />
        <QuoteForm services={services} setServices={setServices} location={location} setLocation={setLocation} tintShade={tintShade} setTintShade={setTintShade} />
      </main>
      <Footer />
      <StickyBar />
    </div>
  );
}
